// extracted by mini-css-extract-plugin
export default {"menuList":"EntitySelectMenuList-module__menuList--Kq0mz","content":"EntitySelectMenuList-module__content--VM4kQ"};